import Service from "../../AuthService";
const BagType = {
    getBagType(page) {
        return Service.get("/bag_type?page="+page);
    },
    showBagType(id) {
        return Service.get("/bag_type/"+id);
    },
    createBagType(data){
        return Service.post("/bag_type",data);
    },
    updateBagType(id,data) {
        return Service.put("/bag_type/"+id ,data);
    },
    deleteBagType(id){
        return Service.delete("/bag_type/"+id);
    },
    searchBagType(data){
        return Service.post('/bag_type_search',data);
    }
};
export default BagType;
